import { PropsWithChildren } from 'react';

export function ModalTitle({ children }: PropsWithChildren<{}>) {
    return <h5 className="inline-modal-title">{children}</h5>;
}
